import { error } from 'console';
import { IResult } from '../models/result-models';
import {
    IFavoritesResult,
    IRecentlyViewedProductsResult,
    IWishListResult,
} from '../models/wish-list';
import { apiDelete, apiGet, apiPost } from './api-utils';
import { IWishList } from '../models/insite';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/wish-list';

export const loadWishlists = async (): Promise<IResult<IWishListResult>> => {
    const result = await apiGet<IWishListResult>(baseUrl);
    return result;
};

export const addFavorite = async (
    productId: string
): Promise<IResult<boolean>> => {
    const result = await apiPost<string, boolean>(
        baseUrl + '/favorite',
        productId
    );
    return result;
};

export const removeFavorite = async (
    productId: string
): Promise<IResult<boolean>> => {
    const result = await apiDelete<boolean>(
        baseUrl + '/favorite?productId=' + productId
    );
    return result;
};

export const addRecentlyViewedProduct = async (
    productId: string
): Promise<IResult<boolean>> => {
    const result = await apiPost<string, boolean>(
        baseUrl + '/recently-viewed-product',
        productId
    );
    return result;
};
